<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="saveButtonAction" title="Save Confirmation - Role Management">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="filter-name">
						{{ model != null ? model.name : "" }}
					</b-form-group>
					<b-form-group id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="filter-description">
						{{ model != null ? model.description : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
<!--APP_DETAIL_TABLE-->
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Role Management Detail</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="roleManagementDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="roleManagementDetails" :fields="fieldsRoleManagementDetail" :busy="isDataLoading" :sort-by.sync="sortByRoleManagementDetail" :sort-desc.sync="sortDescRoleManagementDetail" small responsive>
			<!--APP_TABLE_FILTER-->
			<template v-slot:head(actions)>
				<b-button @click="isShowRoleManagementDetailFilter = !isShowRoleManagementDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowRoleManagementDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Function Info">
					<v-select append-to-body label="name" :options="functionInfos" :value="filterRoleManagementDetail.functionInfoId" :reduce="item => item.id" v-model="filterRoleManagementDetail.functionInfoId" @search="getFunctionInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Allow Create">
					<b-form-checkbox id="input-allow-create-table" class="float-right" v-model="filterRoleManagementDetail.allowCreate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Read">
					<b-form-checkbox id="input-allow-read-table" class="float-right" v-model="filterRoleManagementDetail.allowRead"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Update">
					<b-form-checkbox id="input-allow-update-table" class="float-right" v-model="filterRoleManagementDetail.allowUpdate"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Delete">
					<b-form-checkbox id="input-allow-delete-table" class="float-right" v-model="filterRoleManagementDetail.allowDelete"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Show In Menu">
					<b-form-checkbox id="input-show-in-menu-table" class="float-right" v-model="filterRoleManagementDetail.showInMenu"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Download">
					<b-form-checkbox id="input-allow-download-table" class="float-right" v-model="filterRoleManagementDetail.allowDownload"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Print">
					<b-form-checkbox id="input-allow-print-table" class="float-right" v-model="filterRoleManagementDetail.allowPrint"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="Allow Upload">
					<b-form-checkbox id="input-allow-upload-table" class="float-right" v-model="filterRoleManagementDetail.allowUpload"></b-form-checkbox>
				</b-th>
				<b-th></b-th>
			</template>
			<!--END_APP_TABLE_FILTER-->
			<!--APP_TABLE_DATA-->
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( roleManagementDetailPageSize * (currentRoleManagementDetailPage - 1))) }}
			</template>
			<template v-slot:cell(roleManagement)="row">
				{{ row.item.roleManagement != null ? row.item.roleManagement.name : "" }}
			</template>
			<template v-slot:cell(functionInfo)="row">
				{{ row.item.functionInfo != null ? row.item.functionInfo.name : "" }}
			</template>
			<!--END_APP_TABLE_DATA-->
			</b-table>
			</div>
		</b-col>
		<b-col cols="12">
			<!--APP_TABLE_PAGINATION-->
			<b-pagination
			class="float-right btn-paging"
			v-model="currentRoleManagementDetailPage"
			:total-rows="totalRoleManagementDetailRow"
			:per-page="roleManagementDetailPageSize"
			aria-controls="my-table"
			></b-pagination>
			<!--END_APP_TABLE_PAGINATION-->
		</b-col>
		</b-row>
	</b-card>
<!--END_APP_DETAIL_TABLE-->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import RoleManagement from '@/models/RoleManagement/RoleManagement';
import RoleManagementList from '@/models/RoleManagement/RoleManagementList';
import RoleManagementFilter from '@/filters/RoleManagement/RoleManagementFilter';

import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';
import RoleManagementDetailFilter from '@/filters/RoleManagement/RoleManagementDetailFilter';
import FunctionInfo from '@/models/Core/FunctionInfo';
import FunctionInfoFilter from '@/filters/Core/FunctionInfoFilter';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	/*APP_DETAIL_PROP_DEFINITION*/
	props : ["openPopup", "modelId", "saveActionMethod", "resetMethod"],
	/*END_APP_DETAIL_PROP_DEFINITION*/
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			model: {},
			datas: Array(),
			fieldsRoleManagementDetail: [
				{"no" : {  "class" : "th-number" }},
				{"functionInfo": {},  "class" : "th-function-info", "label" : "Function Info", key: 'functionInfo', sortable: true}, 
				{"allowCreate": {},  "class" : "th-allow-create", "label" : "Allow Create", key: 'allowCreate', sortable: true}, 
				{"allowRead": {},  "class" : "th-allow-read", "label" : "Allow Read", key: 'allowRead', sortable: true}, 
				{"allowUpdate": {},  "class" : "th-allow-update", "label" : "Allow Update", key: 'allowUpdate', sortable: true}, 
				{"allowDelete": {},  "class" : "th-allow-delete", "label" : "Allow Delete", key: 'allowDelete', sortable: true}, 
				{"showInMenu": {},  "class" : "th-show-in-menu", "label" : "Show In Menu", key: 'showInMenu', sortable: true}, 
				{"allowDownload": {},  "class" : "th-allow-download", "label" : "Allow Download", key: 'allowDownload', sortable: true}, 
				{"allowPrint": {},  "class" : "th-allow-print", "label" : "Allow Print", key: 'allowPrint', sortable: true}, 
				{"allowUpload": {},  "class" : "th-allow-upload", "label" : "Allow Upload", key: 'allowUpload', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			/*APP_DETAIL_PAGINATION*/
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterRoleManagement : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentRoleManagementPage : 1,
			roleManagementPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByRoleManagement: '',
			sortDescRoleManagement: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			filterRoleManagementDetail : null,
			currentRoleManagementDetailPage : 1,
			roleManagementDetailPageSize: 10,
			sortByRoleManagementDetail: '',
			sortDescRoleManagementDetail: '',
			sortingByRoleManagementDetail: [],
			roleManagementDetails : [],
			roleManagementDetailId : '',
			totalRoleManagementDetailRow : 0,
			isShowRoleManagementDetailFilter: false,
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			functionInfos: [],
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETRoleManagement*/
		getRoleManagement : async function(id) {
			this.isBusy = true;
			RoleManagement.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETRoleManagement*/
		/*APP_DETAIL_GETRoleManagementDetail*/
		getRoleManagementDetails : async function() {
			let filter = {};
			Object.assign(filter, this.filterRoleManagementDetail);
			if (this.modelId == null) return;
			filter.roleManagementId = this.modelId;
			this.sortingByRoleManagementDetail = Array();
			if (this.sortByRoleManagementDetail != null) {
				this.sortingByRoleManagementDetail[this.sortByRoleManagementDetail] = this.sortDescRoleManagementDetail;
			}
			let currentPage = (this.currentRoleManagementDetailPage - 1);
			RoleManagementDetail.getList(this, filter, this.sortingByRoleManagementDetail, currentPage , this.roleManagementDetailPageSize).then(result => {
				this.roleManagementDetails = result.data;
				this.totalRoleManagementDetailRow = result.dataCount;
			}).catch(error => {});
		},
		/*END_APP_DETAIL_GETRoleManagementDetail*/
		/*APP_DETAIL_GETFUNCTIONINFO*/
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},
		/*END_APP_DETAIL_GETFUNCTIONINFO*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'rolemanagementcopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_SAVEBUTTONACTION*/
		saveButtonAction(modalEvent) {
			this.$emit("saveActionMethod", modalEvent);
		},
		/*END_APP_DETAIL_SAVEBUTTONACTION*/
		/*APP_DETAIL_RESETMODAL*/
		resetModal() {
			this.$emit('resetMethod'); 
		},
		/*END_APP_DETAIL_RESETMODAL*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowRoleManagementDetailFilter = true;
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterRoleManagement = new RoleManagementFilter();
		this.filterRoleManagementDetail = new RoleManagementDetailFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	watch : {
		/*APP_DETAIL_OPENPOPUP*/
		openPopup(newValue, oldValue) {
			if (newValue) {
				this.getRoleManagement(this.modelId);
				this.getRoleManagementDetails();
			}
		},
		/*END_APP_DETAIL_OPENPOPUP*/
		/*APP_DETAIL_WATCH_ROLEMANAGEMENTDETAIL*/
		sortByRoleManagementDetail : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		sortDescRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		currentRoleManagementDetailPage: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		roleManagementDetailPageSize : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		filterRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			},
			deep: true,
		},
		/*END_APP_DETAIL_WATCH_ROLEMANAGEMENTDETAIL*/
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
		isShowPopup: {
			get: function(){
				if (this.openPopup) return true; 
				else return false; 
			},
			set: function(newValue){ }
		},
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
